/* eslint-disable */
export default {
  request: function (req, token) {
    document.execCommand('ClearAuthenticationCache', 'false');
    this.http.setHeaders.call(this, req, {Authorization: token})
  },
  response: function (res) {
    if (res.config.url.includes('auth/')) {
      if (res.status == 200) {
        let headers = this.http.getHeaders.call(this, res)
        let authorization = headers.Authorization || headers.authorization
        if (authorization) {
          return authorization
        }
      }
    }
  }
}
